import { t } from "@ebay/i18n-ebay";
import { getPropsForClickTracking } from "../../utils/tracking";

<if(input.help)>
  <div class="map-help map-component-with-tooltip">
    <ebay-infotip
      a11y-close-button-text=(input.help.messageDismiss?.textSpans?.[0].text)
      aria-label=(input.help.bubbleIcon?.accessibilityText)
      pointer="right-top"
      open=state.opened
      onCollapse("onCollapse")
      onExpand("onExpand")
      ...getPropsForClickTracking(input.help.bubbleIcon?.action?.trackingList)
    >
      <@heading>
        <fe-textual-display model=(input.help.title)/>
      </@heading>
      <@content>
        <p>
          <fe-textual-display model=(input.help.messageText?.[0])/>
        </p>
      </@content>
    </ebay-infotip>
    <if(!state.opened)>
      <span class="map-component-tooltip">
        <fe-textual-display model=t("mapview/map", "moreInfoTooltipLabel")/>
      </span>
    </if>
  </div>
</if>
